import React from 'react';

import { getText } from './Text';
import { correctOrphanWordInSentence } from '../utils/textHelpers';

export default function MottoHeadline() {
  return (
    <div className="mottoBlock">
      <h1 className="motto">
        {correctOrphanWordInSentence(getText('motto'))}
      </h1>
    </div>
  );
}
